import * as React from 'react';
import { ListAgenciesFeature } from './listAgencies';
import { HeaderSecondary } from '@app/src/common/header';
import { FooterFeature } from '@app/src/common/footer';

export const Agency:React.SFC = () => (
  <React.Fragment>
    <HeaderSecondary navBar />
    <ListAgenciesFeature />
    <FooterFeature isDisplay={true} />
  </React.Fragment>
);
